






















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import AuthStoreModule from '@revas/kadra-library/src/core/auth/vue/vuex/AuthStoreModule'
import CoreStoreModule, { ChangeActiveOrganizationPayload } from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import OrganizationNavigator from '@revas/kadra-library/src/revas/vue/vue-router/OrganizationNavigator'
import VueI18n from 'vue-i18n'

import { ChangeEvent, ChromeLayout, PageLayout, ContainerLayout, LinearLayout, BaseHeading, BaseField, BaseInput, ScrollLayout, BaseModal, BaseAvatarBlock, BaseTabs, BaseAvatar, BaseIcon, BaseButton } from '@revas/reef'

import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'

import Organization from '@revas/kadra-library/src/revas/vue/vuex/models/Organization'
import User from '@revas/kadra-library/src/revas/vue/vuex/models/User'

import AppStoreDownloadSpinner from '@/components/shop/AppStoreDownloadSpinner.vue'

import { SystemInfo } from '../models'

@Component({
  components: {
    ChromeLayout,
    ContainerLayout,
    PageLayout,
    LinearLayout,
    ScrollLayout,
    BaseModal,
    BaseField,
    BaseInput,
    BaseAvatarBlock,
    BaseHeading,
    BaseTabs,
    BaseAvatar,
    BaseIcon,
    BaseButton,
    AppStoreDownloadSpinner
  }
})
export default class OrganizationLayout extends Vue {
  @Prop() authStoreModule!: AuthStoreModule
  @Prop() coreStoreModule!: CoreStoreModule
  @Prop() appStoreModule!: AppStoreModule
  @Prop() organizationId!: string
  @Prop() navigator!: OrganizationNavigator
  @Prop() i18n!: VueI18n
  @Prop() baseUrl!: string
  @Prop() systemInfo!: SystemInfo

  get organization (): Organization {
    const o = this.coreStoreModule.activeUserOrganization
    return o === null ? new Organization() : o
  }

  get user (): User {
    const u = this.coreStoreModule.userProfile
    return u === null ? new User() : u
  }

  @Watch('organizationId', { immediate: true })
  async onRouteUpdate (value: string | undefined) {
    console.log('systemInfo', this.systemInfo)
    if (value === undefined) {
      return
    }
    if (value === '-') {
      this.navigator.changeOrganization('-')
      return
    }
    const payload = new ChangeActiveOrganizationPayload()
    payload.organizationId = value
    this.coreStoreModule.asyncChangeActiveOrganization(payload)
  }

  onOrganizationSelected (event: ChangeEvent<Organization>) {
    if (event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.navigator.changeOrganization(event.value.id)
  }

  //
  //
  // Organization Selection
  get organizations () {
    const o = this.coreStoreModule.userOrganizations
    if (o !== null) {
      return o
    } else {
      return []
    }
  }

  private showSelect = false

  private search = ''
  get filteredOrganizations () {
    if (this.search === '') {
      return this.organizations
    }
    return this.organizations.filter((o) => {
      return o.name.toLowerCase().includes(this.search.toLowerCase())
    })
  }

  showLoading = false

  async changeOrganization (organization: Organization) {
    this.showOptions = false
    this.showLoading = true

    setTimeout(() => {
      this.navigator.changeOrganization(organization.id)
    }, 1200)
  }

  get organizationUrl () {
    return `/organizations/#/o/${this.organizationId}/r`
  }

  showPanel = false
  showOptions = false

  showOrganizationSwitcher () {
    this.showSelect = true
    setTimeout(() => {
      this.showOptions = true
      this.showPanel = true
    }, 800)
  }

  closeOrganizationSwitch () {
    this.showPanel = false
    setTimeout(() => {
      this.showSelect = false
    }, 500)
  }

  //
  //
  // Create organization
  createOrganization () {
    window.location.href = '/organizations/?create=true'
  }

  get organizationNameShort () {
    const name = this.organization.name
    let shortName = ''
    if (name && name !== '') {
      if (name.length > 10) {
        shortName = this.organization.name.slice(0, 10) + '...'
      } else {
        shortName = name
      }
    }
    return shortName
  }

  async logout () {
    await this.authStoreModule.asyncLogout()
  }
}
